import type { NewsItem } from "@/types";

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "星光传媒《星际回响》定档暑期 科幻视效再攀新高度",
    category: "release",
    date: "2026-09-28",
    source: "星光传媒资讯中心",
    summary:
      "由星光影业出品、苏渡执导的科幻巨制《星际回响》正式宣布定档暑期，影片历时三年打磨，视觉特效与叙事格局双双升级。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20news%20banner%20of%20an%20astronaut%20before%20a%20giant%20glowing%20planet%2C%20deep%20blue%20space%20with%20warm%20orange%20nebula%20lights%2C%20epic%20scale%20and%20high%20detail%2C%20professional%20editorial%20visual&width=800&height=500&seq=news-cover-n1&orientation=landscape",
    content: [
      "星光传媒今日正式宣布，由旗下星光影业出品的科幻电影《星际回响》将于暑期档登陆全国院线。影片由知名导演苏渡执导，程野、覃阳、白榆领衔主演，历时三年筹备与拍摄，是星光传媒近年来投入规模最大的科幻作品之一。",
      "据主创团队介绍，《星际回响》在视觉呈现上采用了大量前沿的实拍与特效结合技术，力求在浩瀚宇宙的宏大叙事中，保留人物细腻真实的情感表达。影片围绕人类收到来自四光年之外的神秘信号展开，讲述一支探险队踏上深空之旅的故事。",
      "在发布会上，导演苏渡表示：“我们想讲的不是一个关于征服宇宙的故事，而是关于人在巨大未知面前如何保持希望与连接。”制片方透露，影片的世界观设定与美术概念均由专业团队历时一年多打磨完成。",
      "业内人士认为，随着国内科幻题材创作的不断成熟，《星际回响》有望成为暑期档最具话题度的作品之一。星光传媒表示，后续还将围绕影片推出系列幕后纪录片与主题展览，持续丰富观众的观影体验。",
    ],
  },
  {
    id: "n2",
    title: "行业观察｜2026 上半年国产剧集市场：现实题材持续升温",
    category: "industry",
    date: "2026-09-20",
    source: "星光传媒研究院",
    summary:
      "最新数据显示，2026 年上半年国产剧集市场中，现实题材与都市职场类作品表现亮眼，观众对真实质感与情感共鸣的期待进一步提高。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20banner%20of%20a%20glowing%20city%20skyline%20at%20dusk%20with%20data%20charts%20overlay%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20professional%20business%20media%20visual&width=800&height=500&seq=news-cover-n2&orientation=landscape",
    content: [
      "根据星光传媒研究院最新发布的行业报告，2026 年上半年国产剧集市场整体供给平稳，现实题材作品在口碑与热度上均取得不错的表现。都市、职场、家庭等贴近生活的题材，成为观众讨论的焦点。",
      "报告指出，观众对于“真实质感”的需求正在提升。相较于过度戏剧化的情节，越来越多的作品开始关注普通人的情感与成长，这种贴近生活的表达方式更容易引发共鸣。",
      "与此同时，剧集的制作水准也在稳步提高。从摄影、美术到后期调色，国产剧集的工业化程度不断增强，为优质内容的规模化生产提供了基础。",
      "业内分析认为，未来一段时间内，现实题材仍将是市场的重要方向之一。如何在真实与艺术之间找到平衡，将是创作者持续面对的课题。",
    ],
  },
  {
    id: "n3",
    title: "人物访谈｜导演陈墨：悬疑的外壳下，我讲的是人心",
    category: "interview",
    date: "2026-09-12",
    source: "星光传媒对话栏目",
    summary:
      "从《暗流之城》到正在筹备的新作，导演陈墨分享了他对悬疑题材的理解——类型只是外壳，真正打动人的始终是人物与人心。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20portrait%20scene%20of%20a%20director%20chair%20and%20film%20camera%20on%20a%20dim%20set%2C%20deep%20blue%20shadows%20with%20warm%20orange%20practical%20light%2C%20professional%20magazine%20interview%20visual&width=800&height=500&seq=news-cover-n3&orientation=landscape",
    content: [
      "在《暗流之城》获得广泛好评之后，导演陈墨并没有急于开机新项目，而是花了大量时间打磨剧本。在他看来，一个好的悬疑故事，首先要有一个立得住的人物。",
      "“类型只是外壳。”陈墨在访谈中反复强调，“观众记住的从来不是反转本身，而是面对真相时人物的选择。悬疑的紧张感，最终要服务于情感的张力。”",
      "谈到创作方法，陈墨坦言自己习惯从细节入手。“一个反复出现的物件、一句没说出口的话，往往比大段的台词更有力量。我希望观众在离场之后，还能想起某个画面。”",
      "对于未来，陈墨表示仍会在类型与情感之间继续探索。“我希望每一部作品都能让观众在紧张之余，感受到一点温度。这是我做电影最想守住的东西。”",
    ],
  },
  {
    id: "n4",
    title: "星光传媒传媒服务中心升级 全链路赋能影视制作",
    category: "company",
    date: "2026-09-05",
    source: "星光传媒官方",
    summary:
      "星光传媒宣布对旗下传媒服务中心进行全面升级，新增前期策划、宣传发行、新媒体运营等多项服务，为影视项目提供从创意到落地的全链路支持。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20banner%20of%20a%20modern%20media%20production%20studio%20with%20creative%20team%20working%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20clean%20business%20visual%2C%20high%20detail&width=800&height=500&seq=news-cover-n4&orientation=landscape",
    content: [
      "星光传媒今日宣布，旗下传媒服务中心完成全面升级并正式对外服务。升级后的中心整合了前期策划、拍摄制作、宣传发行与新媒体运营等核心能力，可为不同类型客户提供一站式影视内容解决方案。",
      "据了解，此次升级的重点在于打通项目全流程。从创意孵化阶段的剧本打磨，到拍摄期的制作管理，再到后期的宣传推广与渠道发行，中心均可提供标准化与定制化相结合的服务。",
      "星光传媒相关负责人表示：“我们希望通过更完整的服务链路，帮助更多好故事被看见。无论是正在起步的创作团队，还是寻求宣传突破的品牌客户，都能在这里找到合适的支持。”",
      "该负责人还透露，中心后续将定期举办行业交流活动与创作沙龙，搭建创作者与产业之间的沟通桥梁，推动优质内容的持续产出。",
    ],
  },
  {
    id: "n5",
    title: "《长夜将明》口碑持续走高 古装历史剧再获关注",
    category: "release",
    date: "2026-08-26",
    source: "星光传媒资讯中心",
    summary:
      "由星光影业出品的历史剧集《长夜将明》播出后口碑持续走高，其扎实的剧本、考究的服化道与演员的细腻表演收获观众一致好评。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20banner%20of%20an%20ancient%20palace%20courtyard%20at%20night%20in%20falling%20snow%2C%20deep%20blue%20cold%20light%20with%20warm%20lantern%20glow%2C%20dramatic%20cinematic%20mood%2C%20high%20detail&width=800&height=500&seq=news-cover-n5&orientation=landscape",
    content: [
      "历史剧集《长夜将明》自开播以来，凭借扎实的剧本结构与考究的制作水准，收获了来自观众与业内人士的广泛好评。该剧由星光影业出品，顾之执导，沈砚、陆昀、姜晚主演。",
      "不少观众表示，剧集在历史氛围的营造上颇为用心，从场景搭建到服装道具，都体现出对细节的尊重。演员的表演克制而富有层次，为人物赋予了真实的情感重量。",
      "主创团队在采访中透露，为了让故事更贴近历史质感，剧组在前期进行了大量的资料研究，并邀请相关领域顾问参与创作，力求在艺术表达与历史逻辑之间取得平衡。",
      "随着剧情的推进，《长夜将明》的讨论热度持续攀升。有评论认为，该剧为国产历史题材创作提供了一种兼顾口碑与观赏性的思路。",
    ],
  },
  {
    id: "n6",
    title: "星光传媒联合高校启动青年影视人才培养计划",
    category: "company",
    date: "2026-08-15",
    source: "星光传媒官方",
    summary:
      "星光传媒联合多所高校启动青年影视人才培养计划，通过实训项目、导师制与作品孵化，为行业输送具备实战能力的新生力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20banner%20of%20young%20creators%20learning%20in%20a%20modern%20film%20studio%20workshop%2C%20cool%20blue%20tones%20with%20warm%20orange%20accents%2C%20inspiring%20clean%20visual%2C%20high%20detail&width=800&height=500&seq=news-cover-n6&orientation=landscape",
    content: [
      "星光传媒近日宣布，联合多所高校正式启动“青年影视人才培养计划”。该计划面向影视相关专业的在校学生与青年创作者，通过实训项目、导师制与作品孵化，帮助他们更快地完成从课堂到产业的过渡。",
      "据介绍，计划将提供涵盖编剧、导演、摄影、剪辑与制片等多个方向的学习与实践机会。入选学员将在资深从业者的指导下参与真实项目，积累一线经验。",
      "星光传媒表示，人才是内容行业的根基。“我们希望搭建一个开放的平台，让有想法、有热情的青年创作者能够被看见、被支持，也让行业获得源源不断的新生力量。”",
      "首批学员招募已于本月启动，相关课程与实训安排将在后续陆续公布。",
    ],
  },
  {
    id: "n7",
    title: "行业观察｜短剧市场进入精品化阶段 内容质量成竞争核心",
    category: "industry",
    date: "2026-09-01",
    source: "星光传媒研究院",
    summary:
      "随着观众审美与平台标准的提升，短剧市场正从数量竞争转向质量竞争，精品化与专业化成为行业关键词。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20editorial%20banner%20of%20a%20smartphone%20screen%20glowing%20with%20video%20frames%20in%20a%20dark%20studio%2C%20cool%20blue%20tones%20with%20warm%20orange%20highlights%2C%20modern%20media%20visual%2C%20high%20detail&width=800&height=500&seq=news-cover-n7&orientation=landscape",
    content: [
      "过去一年，短剧市场经历了爆发式增长，也迎来了观众的审美升级。越来越多的从业者意识到，短平快的叙事并不能长久留住用户，内容质量才是立足之本。",
      "根据星光传媒研究院的观察，精品化正在成为行业共识。从剧本打磨到拍摄制作，从演员选择到后期剪辑，短剧的制作标准正在向传统影视剧靠拢。",
      "与此同时，平台也在加强对内容质量的引导。专业的创作团队、规范的生产流程与可持续的商业模式，正在共同推动行业走向成熟。",
      "业内分析认为，未来短剧与长剧之间并非替代关系，而是各自寻找合适的表达空间。对创作者而言，在有限的时长里讲好一个完整的故事，将是长期的能力考验。",
    ],
  },
  {
    id: "n8",
    title: "技术前沿｜虚拟拍摄走进国产剧组 影视工业化按下加速键",
    category: "industry",
    date: "2026-08-20",
    source: "星光传媒研究院",
    summary:
      "LED 虚拟拍摄技术正被越来越多国产剧组应用，在提升拍摄效率的同时，也为创作者带来了全新的想象空间。",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20editorial%20banner%20of%20an%20LED%20virtual%20production%20volume%20stage%20with%20a%20film%20camera%2C%20deep%20blue%20ambient%20lighting%20with%20warm%20orange%20accents%2C%20high%20detail%20technology%20visual&width=800&height=500&seq=news-cover-n8&orientation=landscape",
    content: [
      "在传统拍摄中，复杂的实景与后期合成往往占据大量时间与成本。而 LED 虚拟拍摄技术，则通过实时渲染的背景墙，将场景直接呈现在演员面前。",
      "据参与相关项目的技术人员介绍，虚拟拍摄不仅让表演更加自然，也让创作有了更多试错与调整的空间。导演可以在现场实时看到接近成片的画面效果。",
      "当然，技术的应用也带来了新的挑战。从前期的资产制作到现场的灯光配合，都需要更专业的团队协作，这对影视工业化水平提出了更高要求。",
      "业内普遍认为，虚拟拍摄并非要取代传统拍摄，而是为创作者提供更多选择。如何让技术服务创作，仍是行业需要持续探索的课题。",
    ],
  },
  {
    id: "n9",
    title: "星光传媒亮相行业峰会 分享内容创作与人才培养经验",
    category: "company",
    date: "2026-08-08",
    source: "星光传媒官方",
    summary:
      "在年度行业峰会上，星光传媒围绕内容创作与人才培养分享了实践经验，引发与会嘉宾的广泛讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Professional%20corporate%20banner%20of%20a%20large%20conference%20stage%20with%20a%20speaker%20and%20audience%20silhouettes%2C%20cool%20blue%20tones%20with%20warm%20orange%20stage%20lights%2C%20business%20visual%2C%20high%20detail&width=800&height=500&seq=news-cover-n9&orientation=landscape",
    content: [
      "在近日举办的影视行业峰会上，星光传媒受邀参与圆桌讨论，与来自制作、发行与平台方的嘉宾共同探讨内容创作的未来。",
      "星光传媒代表在分享中表示，优质内容的生产离不开稳定的创作机制与长期投入。“我们更愿意把时间花在前期的打磨上，而不是仓促地开始。”",
      "在人才培养方面，星光传媒介绍了正在推进的青年影视人才培养计划，通过与高校合作，为行业输送具备实战能力的新生力量。",
      "与会嘉宾认为，内容行业的下一个阶段，比拼的将是体系化能力。谁能在创作、制作与人才之间建立起良性循环，谁就能走得更远。",
    ],
  },
  {
    id: "n10",
    title: "《活力无限》新一季开播 阵容与玩法全面升级",
    category: "release",
    date: "2026-08-02",
    source: "星光传媒资讯中心",
    summary:
      "大型户外竞技真人秀《活力无限》新一季正式开播，全新阵容与升级玩法为观众带来耳目一新的观看体验。",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20banner%20of%20contestants%20celebrating%20on%20a%20bright%20colorful%20stage%20with%20confetti%2C%20vivid%20orange%20lighting%20with%20cool%20blue%20backdrop%2C%20fun%20energetic%20visual&width=800&height=500&seq=news-cover-n10&orientation=landscape",
    content: [
      "由星光传媒出品的大型户外竞技真人秀《活力无限》新一季已于近日开播。节目在延续竞技与欢乐基调的同时，对赛制与玩法进行了全面升级。",
      "新一季邀请到多位风格各异的常驻嘉宾，并引入素人选手同场竞技。节目组表示，希望让更多人有机会站上舞台，展现普通人的活力与坚持。",
      "在场景设计上，新一季的关卡更加丰富，融入了地域文化与环保主题，让竞技之外也多了几分温度与意义。",
      "节目首播后，相关话题迅速登上社交平台热榜。不少观众表示，这档节目在紧张之余带来的轻松与治愈，正是当下人们所需要的。",
    ],
  },
  {
    id: "n11",
    title: "《都市脉搏》温暖收官 现实题材引发广泛共鸣",
    category: "release",
    date: "2026-07-25",
    source: "星光传媒资讯中心",
    summary:
      "剧集《都市脉搏》迎来收官，真实的职场刻画与细腻的情感表达，让这部现实题材作品收获了观众的真挚回应。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20banner%20of%20a%20glowing%20city%20skyline%20at%20dusk%2C%20cool%20blue%20tones%20with%20warm%20orange%20sunset%20reflection%2C%20sleek%20cinematic%20visual%2C%20high%20detail&width=800&height=500&seq=news-cover-n11&orientation=landscape",
    content: [
      "由星光影业出品的都市职场剧《都市脉搏》近日迎来收官。该剧以一家高速成长的科技公司为背景，讲述一群年轻人奋力奔跑的故事。",
      "播出期间，剧中对职场细节的真实呈现引发了大量讨论。不少观众表示，在角色身上看到了自己的影子，也在其中获得了继续前行的力量。",
      "主创团队表示，创作之初就希望把镜头对准普通人。“我们不想塑造完美的人，而是想呈现真实的选择与成长。”",
      "随着大结局的播出，“都市脉搏”相关话题再次引发热议。有评论认为，这部剧为现实题材创作提供了一种兼具温度与思考的表达方式。",
    ],
  },
  {
    id: "n12",
    title: "人物访谈｜制片人温言：好的项目，是多方克制的结果",
    category: "interview",
    date: "2026-07-18",
    source: "星光传媒对话栏目",
    summary:
      "从剧集到电影，制片人温言分享了她的项目经验——比起无限扩张，懂得克制，往往才是好作品的开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20scene%20of%20a%20producer%20desk%20with%20scripts%20notebooks%20and%20a%20warm%20lamp%2C%20deep%20blue%20shadows%20with%20warm%20orange%20glow%2C%20professional%20magazine%20interview%20visual&width=800&height=500&seq=news-cover-n12&orientation=landscape",
    content: [
      "作为制片人，温言参与过多部剧集与电影项目。在她看来，制片工作的核心并非“什么都做”，而是清楚地知道该做什么、该舍弃什么。",
      "“好的项目，是多方克制的结果。”温言说，“预算要有边界，创作要有取舍，所有环节都得围绕故事本身服务，而不是不断增加噱头。”",
      "谈到与导演、编剧的合作，她强调沟通的重要性。“制片人要做的，是让创作者能够安心创作，同时确保项目在合理的轨道上推进。”",
      "对于年轻从业者，温言给出了质朴的建议：“先把一件小事做到最好。能力是在一个个具体的项目里长出来的，而不是想出来的。”",
    ],
  },
];